export const CodeReaderQcFieldName = 'codeReaderQcFieldComponent';
